import React from "react";
import "react-native-gesture-handler";
import { Provider } from "react-redux";
import RootStack from "./src/screens/RootStack";
import store from "./src/store";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider as PaperProvider } from "react-native-paper";
import FlashMessage from "react-native-flash-message";
import theme from "./src/store/theme";
import { useFonts } from "expo-font";
import { USE_MOCK_API, seedMockStorage } from "./src/mocks";
import registerServiceWorker from "./src/web/registerServiceWorker";

//import { useState, useEffect, useRef } from "react";
//import { Text, View, Button, Platform } from "react-native";
// import * as Device from "expo-device";
// import * as Notifications from "expo-notifications";
//import useApi from "./src/hooks/useAPI";

const queryClient = new QueryClient();

// Notifications.setNotificationHandler({
// 	handleNotification: async () => ({
// 		shouldShowAlert: true,
// 		shouldPlaySound: true,
// 		shouldSetBadge: true,
// 	}),
// });

// async function schedulePushNotification() {
// 	await Notifications.scheduleNotificationAsync({
// 		//O que enviar junto com a notificação? título, mensagem (body), etc.
// 		content: {
// 			title: "Notification! 📬",
// 			body: "Here is the notification body",
// 			data: { data: "goes here" },
// 		},
// 		trigger: { seconds: 2 }, //quanto tempo esperar antes de lançar a notificação?
// 	});
// }

export default function App() {
	//const api = useApi();

	// async function registerForPushNotificationsAsync() {
	// 	let token;
	// 	if (Device.isDevice) {
	// 		const { status: existingStatus } =
	// 			await Notifications.getPermissionsAsync();
	// 		let finalStatus = existingStatus;
	// 		if (existingStatus !== "granted") {
	// 			const { status } = await Notifications.requestPermissionsAsync();
	// 			finalStatus = status;
	// 		}
	// 		if (finalStatus !== "granted") {
	// 			alert("Failed to get push token for push notification!");
	// 			return;
	// 		}
	// 		token = (await Notifications.getExpoPushTokenAsync()).data;

	// 		console.log(token);

	// 		const { data } = await api.firstAccess.saveNotificationToken(token);

	// 		console.log({ data });
	// 	} else {
	// 		alert("Must use physical device for Push Notifications");
	// 	}

	// 	if (Platform.OS === "android") {
	// 		Notifications.setNotificationChannelAsync("default", {
	// 			name: "default",
	// 			importance: Notifications.AndroidImportance.MAX,
	// 			vibrationPattern: [0, 250, 250, 250],
	// 			lightColor: "#FF231F7C",
	// 		});
	// 	}

	// 	return token;
	// }

	// const [expoPushToken, setExpoPushToken] = useState("");
	// const [notification, setNotification] = useState(false);
	// const notificationListener = useRef();
	// const responseListener = useRef();

	// useEffect(() => {
	// 	registerForPushNotificationsAsync().then(token => setExpoPushToken(token));

	// 	notificationListener.current =
	// 		Notifications.addNotificationReceivedListener(notification => {
	// 			setNotification(notification);
	// 		});

	// 	responseListener.current =
	// 		Notifications.addNotificationResponseReceivedListener(response => {
	// 			console.log(response);
	// 		});

	// 	return () => {
	// 		Notifications.removeNotificationSubscription(
	// 			notificationListener.current
	// 		);
	// 		Notifications.removeNotificationSubscription(responseListener.current);
	// 	};
	// }, []);

	const [fontsLoaded] = useFonts({
		DmSans: require("./assets/fonts/DMSans-Regular.ttf"),
		"DmSans-bold": require("./assets/fonts/DMSans-Bold.ttf"),
	});

	React.useEffect(() => {
		registerServiceWorker();
		if (USE_MOCK_API) seedMockStorage();
	}, []);

	return (
		<Provider store={store}>
			<QueryClientProvider client={queryClient}>
				<PaperProvider theme={theme}>
					<RootStack />
					<FlashMessage position="top" floating />
				</PaperProvider>
			</QueryClientProvider>
		</Provider>
	);
}
